/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.tripenhancer.app/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.tripenhancer.app)

Coded by www.tripenhancer.app

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
//TODO
/* eslint-disable no-unused-vars */

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";
import Information from "pages/Presentation/sections/Information";
import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
import Pages from "pages/Presentation/sections/Pages";
import Testimonials from "pages/Presentation/sections/Testimonials";
import Download from "pages/Presentation/sections/Download";

// Presentation page components
import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

//internationilization
import { Suspense } from "react";
import { useTranslation } from "react-i18next";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/earth-map-blue.jpeg";
import badgeImage from "assets/images/android-planet-badge.png";

//Google analytics
import ReactGA from "react-ga4";
import ScreenshotGallery from "./components/ScreenshotGallery";

function Presentation() {
  ReactGA.send({
    hitType: "pageview",
    page: "/",
    title: "Presentation",
  });

  const { t } = useTranslation();

  let seeexlabel = t("presentation.seeexample");
  let safelistening = t("presentation.safelistening");

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://play.google.com/store/apps/details?id=com.naxx.tripenhancer.free",
          label: t("presentation.installapp"),
          color: "info",
        }}
        sticky
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              TripEnhancer
            </MKTypography>
            <MKTypography
              variant="h5"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {t("presentation.tagline")}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {t("presentation.subtitle")}
            </MKTypography>
          </Grid>
        </Container>
        <MKBox
          component="img"
          src={badgeImage}
          alt="AndroidPlanet.nl Winner Week 9/2025"
          sx={{
            position: "absolute",
            top: "20%",
            right: "5%",
            transform: "translateY(-50%)",
            width: "100px",
          }}
        />
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <Container sx={{ mt: 6 }}>
          <ScreenshotGallery />
        </Container>
        <Information />
        <DesignBlocks />
        <Pages />
        <Container sx={{ mt: 6 }}>
          <BuiltByDevelopers />
        </Container>
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4}>
              <FilledInfoCard
                variant="gradient"
                color="info"
                icon="flag"
                title={t("presentation.safelistening")}
                description={t("presentation.safelisteningdesc")}
                action={{
                  type: "external",
                  route:
                    "https://partner.bol.com/click/click?p=2&t=url&s=59205&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fbe%2Fnl%2Fp%2Fcasque-a-conduction-osseuse-bluetooth-shokz-openrun-noir%2F9300000072595817%2F&name=Shokz%20OpenRun%20-%20Bone%20Conduction%20-%20Sporthoofdte...",
                  label: safelistening,
                }}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FilledInfoCard
                color="info"
                icon="precision_manufacturing"
                title={t("presentation.idealearphones")}
                description={t("presentation.idealearphonesdesc")}
                action={{
                  type: "external",
                  route:
                    "https://partner.bol.com/click/click?p=2&t=url&s=59205&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fbe%2Fnl%2Fp%2Fcasque-a-conduction-osseuse-bluetooth-shokz-openrun-noir%2F9300000072595817%2F&name=Shokz%20OpenRun%20-%20Bone%20Conduction%20-%20Sporthoofdte...",
                  label: seeexlabel,
                }}
              />
            </Grid>
            <Grid item xs={12} lg={4}>
              <FilledInfoCard
                color="info"
                icon="apps"
                title={t("presentation.shokz")}
                description={t("presentation.triathleteshokz")}
                action={{
                  type: "external",
                  route:
                    "https://partner.bol.com/click/click?p=2&t=url&s=59205&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fbe%2Fnl%2Fp%2Fcasque-a-conduction-osseuse-bluetooth-shokz-openrun-noir%2F9300000072595817%2F&name=Shokz%20OpenRun%20-%20Bone%20Conduction%20-%20Sporthoofdte...",
                  label: "Shop Shokz",
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <Testimonials />
        <Download />
        <MKBox pt={18} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  {t("presentation.thankyou")}
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  {t("presentation.bestexperience")}
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="https://twitter.com/intent/tweet?text=Check%20the%20TripEnhancer%20App%23mui5&amp;url=https%3A%2F%2Fwww.tripenhancer.app"
                  target="_blank"
                  color="twitter"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-twitter" />
                  &nbsp;Tweet
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.facebook.com/sharer/sharer.php?u=https://www.tripenhancer.app"
                  target="_blank"
                  color="facebook"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-facebook" />
                  &nbsp;Share
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.pinterest.com/pin/create/button/?url=https://www.tripenhancer.app"
                  target="_blank"
                  color="pinterest"
                >
                  <i className="fab fa-pinterest" />
                  &nbsp;Pin it
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Presentation;
